import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {Router} from "@angular/router";
import {NzMessageService} from "ng-zorro-antd/message";
import {lastValueFrom} from "rxjs";
import {PTPStepConfigDto, PerFormaAPIService} from "src/app/services/pfapi.service";
import {PTPStepTypeLabels} from "../ptp-step/ptp-step-types";

interface PTPStepRow extends PTPStepConfigDto {
    stepTypeLabel: string;
}

@Component({
    selector: "app-ptp-step",
    templateUrl: "./ptp-step.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PTPStepComponent implements OnInit {
    constructor(
        private readonly api: PerFormaAPIService,
        private router: Router,
        private message: NzMessageService
    ) {}

    loading = true;
    steps: PTPStepRow[] = [];

    async ngOnInit() {
        await this.getData();
    }

    getData = async () => {
        this.loading = true;
        try {
            const steps = await lastValueFrom(this.api.getApiConfigurePtpSteps());
            // precompute the display label so the template binds a property (no method calls).
            this.steps = steps.map(s => ({...s, stepTypeLabel: PTPStepTypeLabels[s.StepType ?? 0] ?? ""}));
        } catch (e) {
            this.message.error("Failed to fetch steps");
            console.log(e);
        } finally {
            this.loading = false;
        }
    };

    addStep = () => {
        this.router.navigateByUrl("/configure/ptpstepcreate");
    };

    editStep = (id: number) => {
        this.router.navigate(["/configure/ptpstepedit"], {queryParams: {id}});
    };

    deleteStep = async (id: number) => {
        this.loading = true;
        try {
            await lastValueFrom(this.api.deleteApiConfigurePtpStepsId(id));
            this.message.success("Step deleted");
            await this.getData();
        } catch (e) {
            this.message.error("Failed to delete step");
            console.log(e);
            this.loading = false;
        }
    };

    reorder = async (id: number, order: number) => {
        if (order < 0) return;
        this.loading = true;
        try {
            await lastValueFrom(this.api.putApiConfigurePtpStepsIdReorder(id, {order}));
            await this.getData();
        } catch (e) {
            this.message.error("Failed to reorder step");
            console.log(e);
            this.loading = false;
        }
    };
}
